import Vue from "vue";
import App from "./app.vue";
import "./scss/bootstrap-overrides.scss";
import "./scss/_nucleo-glyph.scss";
import "bootstrap";

Vue.config.productionTip = false;

let vueData;
if (process.env.NODE_ENV == "development") {
  vueData = require("../mocks/vanguard.json");
} else {
  vueData = itemData;
}

new Vue({
  provide: {
    contentData: vueData.additionalAttributes.aem.content,
    brandData: vueData.additionalAttributes.aem.brand,
    vueData,
  },
  render: (h) => h(App),
}).$mount("#app");
